class LogoWallCycle extends HTMLElement {
    connectedCallback() {
        this.delay = 2;
        this.duration = 0.35;
        this.lastIndex = -1;

        this.mm = gsap.matchMedia();

        this.mm.add("(min-width: 1024px)", () => {
            return this.initDesktop();
        });

        this.mm.add("(max-width: 1023px)", () => {
            return this.initMobile();
        });
    }

    /* =========================
       DESKTOP SWAP
    ========================== */

    initDesktop() {
        this.items = Array.from(
            this.querySelectorAll('[data-logo-wall-item]')
        );

        this.visible = this.items.filter(
            el => window.getComputedStyle(el).display !== 'none'
        );

        this.hiddenPool = this.items
            .filter(el => window.getComputedStyle(el).display === 'none')
            .map(el => el.querySelector('img'))
            .filter(Boolean);

        if (!this.visible.length || !this.hiddenPool.length) return;

        const tick = () => {
            if (!this.hiddenPool.length) {
                this.loop = gsap.delayedCall(this.delay, tick);
                return;
            }

            const eligible = this.visible
                .map((_, i) => i)
                .filter(i => i !== this.lastIndex);

            if (!eligible.length) {
                this.loop = gsap.delayedCall(this.delay, tick);
                return;
            }

            const randomIndex =
                eligible[Math.floor(Math.random() * eligible.length)];

            this.lastIndex = randomIndex;

            const container = this.visible[randomIndex];
            const currentImg = container.querySelector('img');
            const nextImg = this.hiddenPool.shift();

            if (!currentImg || !nextImg) {
                this.loop = gsap.delayedCall(this.delay, tick);
                return;
            }

            const newImg = nextImg.cloneNode(true);
            newImg.classList.add('absolute', 'inset-0');

            container.appendChild(newImg);

            gsap.set(container, { position: 'relative', overflow: 'hidden' });

            gsap.fromTo(
                newImg,
                { autoAlpha: 0, y: 80 },
                {
                    autoAlpha: 1,
                    y: 0,
                    duration: this.duration,
                    ease: 'smooth'
                }
            );

            gsap.to(currentImg, {
                autoAlpha: 0,
                y: -80,
                duration: this.duration,
                ease: 'smooth',
                onComplete: () => {
                    this.hiddenPool.push(currentImg);
                    currentImg.remove();
                }
            });

            this.loop = gsap.delayedCall(this.delay, tick);
        };

        this.loop = gsap.delayedCall(this.delay, tick);

        // return cleanup function (GSAP will call this automatically)
        return () => {
            if (this.loop) this.loop.kill();
        };
    }

    /* =========================
       MOBILE MARQUEE
    ========================== */

    initMobile() {
        const tracks = this.querySelectorAll('[data-logo-track]');
        if (!tracks.length) return;

        const tl = gsap.timeline({ repeat: -1 });

        tl.to(tracks, {
            xPercent: -100,
            duration: 20,
            ease: 'none'
        });

        return () => {
            tl.kill();
        };
    }

    disconnectedCallback() {
        if (this.mm) this.mm.kill();
    }
}

customElements.define('logo-wall-cycle', LogoWallCycle);